import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ViewChild,
  TemplateRef,
  ElementRef,
} from "@angular/core";
import { fadeInUp400ms } from "src/@vex/animations/fade-in-up.animation";
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from "@angular/material/form-field";
import { stagger40ms } from "src/@vex/animations/stagger.animation";
import { Subscription, Subject, throwError } from "rxjs";
import { TableColumn } from "src/@vex/interfaces/table-column.interface";
import { MatTableDataSource } from "@angular/material/table";
import { SelectionModel } from "@angular/cdk/collections";
import { MatSort, Sort } from "@angular/material/sort";
import icPhone from "@iconify/icons-ic/twotone-phone";
import icMail from "@iconify/icons-ic/twotone-mail";
import icMap from "@iconify/icons-ic/twotone-map";
import icEdit from "@iconify/icons-ic/twotone-edit";
import icDelete from "@iconify/icons-ic/twotone-delete";
import icSearch from "@iconify/icons-ic/twotone-search";
import icAdd from "@iconify/icons-ic/twotone-add";
import icFilterList from "@iconify/icons-ic/twotone-filter-list";
// import { aioTableLabels } from "src/static-data/aio-table.data";
import icMoreHoriz from "@iconify/icons-ic/twotone-more-horiz";
import icFolder from "@iconify/icons-ic/twotone-folder";
import { AuthService } from "../../auth/authServices";
import { GoogleUrlService } from "src/app/services/google-url.service";
import { DialogService } from "src/app/pages/confirm-dialog-box/confir-dialog-box.service";
import { ToastrService } from "ngx-toastr";
import { FormControl } from "@angular/forms";
import { scaleFadeIn400ms } from "../../../../@vex/animations/scale-fade-in.animation";
import { CalendarService } from "../calendar.service";
import { canCreatePiEncounter } from "../../pi/pi.service";
import { ViewPDFComponent } from "../../user-management/applicant/view-pdf/view-pdf.component";
import {
  canCopyEncounterConsentPermalink,
  copyEncounterConsentPermalinkForRow,
} from "../../user-management/digital-service-master-send";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { debounceTime, distinctUntilChanged, tap, catchError } from "rxjs/operators";
import { MatInput } from "@angular/material/input";
import { ConfigService } from "src/app/services/config.service";
import { Router } from "@angular/router";
import { formatEncounterTypeForDisplay } from "../../pi/pi.service";
@Component({
  selector: "vex-incounter-details",
  templateUrl: "./incounter-details.component.html",
  styleUrls: ["./incounter-details.component.scss"],
  animations: [fadeInUp400ms, stagger40ms, scaleFadeIn400ms],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: "standard",
      } as MatFormFieldDefaultOptions,
    },
  ],
})
export class IncounterDetailsComponent implements OnInit, OnDestroy {
  componentName = "Encounter Tabs";
  permissinArray = [];
  isUnauthorized = false;
  PDFURL: string;
  view: any;
  add: any;
  edit: any;
  del: any;
  userIsAuthenticated = false;
  userId: string;
  private   authStatusSub: Subscription;

  // Status Options
  statusOptions = [
    { label: "Draft", value: "draft" },
    { label: "ANF Sent", value: "ANF" },
    { label: "Requested", value: "Request" },
  ];

  // Selected Statuses
  selectedStatuses: string[] = [];
  selectedStatusLabel: string = "Filter by status";

  columns: TableColumn<any>[] = [
    {
      label: "Applicant name",
      property: "fullName",
      type: "text",
      visible: true,
      cssClasses: ["font-medium"],
      sortable: true,
    },
    {
      label: "Form status",
      property: "status",
      type: "badge",
      visible: true,
      cssClasses: ["text-secondary", "font-medium"],
      sortable: false,
    },
    {
      label: "Organization",
      property: "organizationName",
      type: "text",
      visible: true,
      cssClasses: ["font-medium"],
      sortable: false,
    },
    {
      label: "Physician name",
      property: "physicianName",
      type: "text",
      visible: true,
      cssClasses: ["font-medium"],
      sortable: true,
    },

    {
      label: "Applicant ID",
      property: "applicantID",
      type: "text",
      visible: true,
      cssClasses: ["font-medium"],
      sortable: true,
    },
    {
      label: "Encounter / Case type",
      property: "encounterType",
      type: "text",
      visible: true,
      cssClasses: ["font-medium"],
      sortable: false,
    },
    {
      label: "Evaluation type",
      property: "evaluationType",
      type: "text",
      visible: true,
      cssClasses: ["font-medium"],
      sortable: false,
    },
    {
      // label: "Encounter <br> creation date",
      label: "Encounter creation date",
      property: "createdAt",
      type: "date",
      visible: true,
      cssClasses: ["font-medium"],
      sortable: true,
    },

    {
      // label: "Appointment <br> date",
      label: "Appointment date",
      property: "dateOfAppointment",
      type: "date",
      visible: true,
      cssClasses: ["font-medium"],
      sortable: true,
    },
    {
      // label: "Appointment <br> date",
      label: "Report due date",
      property: "reportDueDate",
      type: "date",
      visible: true,
      cssClasses: ["font-medium"],
      sortable: true,
    },
    {
      label: "Applicant <br> digital service",
      property: "applicantDigitalService",
      type: "badge_4",
      visible: true,
      cssClasses: ["font-medium"],
      sortable: false,
    },
    {
      label: "AA <br> digital service",
      property: "applicantAttorneyDigitalService",
      type: "badge_5",
      visible: true,
      cssClasses: ["font-medium"],
      sortable: false,
    },
    {
      label: "DA <br> digital service",
      property: "defenseDigitalService",
      type: "badge_6",
      visible: true,
      cssClasses: ["font-medium"],
      sortable: false,
    },
    {
      label: "Employer <br> digital service",
      property: "employerDigitalService",
      type: "badge_7",
      visible: true,
      cssClasses: ["font-medium"],
      sortable: false,
    },

    {
      label: "Insurance <br> digital service",
      property: "insuranceDigitalService",
      type: "badge_8",
      visible: true,
      cssClasses: ["font-medium"],
      sortable: false,
    },
    {
      label: "Requested date",
      property: "reqDateRange_start",
      type: "badge_3",
      visible: true,
      cssClasses: ["text-secondary", "font-medium"],
      sortable: false,
    },

    {
      label: "Encounter status",
      property: "status_2",
      type: "verify",
      visible: true,
      cssClasses: ["text-secondary", "font-medium"],
      sortable: true,
    },

    {
      label: "Actions",
      property: "actions",
      type: "button",
      visible: true,
      cssClasses: ["text-secondary", "font-medium"],
      sortable: false,
    },
  ];

  encounters: any[] = [];
  page = 1;
  limit = 20;
  isLoading = false;
  hasMoreData = true;

  dataSource: MatTableDataSource<any> | null;
  selection = new SelectionModel<any>(true, []);
  searchCtrl = new FormControl();
  // labels = aioTableLabels;
  icPhone = icPhone;
  icMail = icMail;
  icMap = icMap;
  icEdit = icEdit;
  icSearch = icSearch;
  icDelete = icDelete;
  icAdd = icAdd;
  icFilterList = icFilterList;
  icMoreHoriz = icMoreHoriz;
  icFolder = icFolder;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>;
  isScrollLoading = false;
  errorMessage: string;
  searchText: string;
  roleName: string;
  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }
  safeUrl: SafeResourceUrl;
  @ViewChild("pdfDialogTemplate") pdfDialogTemplate!: TemplateRef<any>;
  constructor(
    public service: CalendarService,
    private authService: AuthService,
    private googleUrlService: GoogleUrlService,
    private dialog: DialogService,
    private toastr: ToastrService,
    private dialog2: MatDialog,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef,
    private configService: ConfigService,
    private router: Router,
  ) {}
  searchTextChanged = new Subject<string>();
  isSearchLoading: boolean = false;
  private searchDebounceSub?: Subscription;

  ngOnInit() {
    this.PDFURL = this.configService.get('pdfURL');
     this.permissinArray = JSON.parse(localStorage.getItem("permission"));
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();

 this.userIsAuthenticated = this.authService.getIsAuth();
    this.roleName = this.authService.getRoleName();
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe((isAuthenticated) => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
        this.cd.markForCheck();
      });
    

    this.searchDebounceSub = this.searchTextChanged
      .pipe(debounceTime(450), distinctUntilChanged())
      .subscribe((searchText) => {
        this.searchText = searchText?.trim() || "";
        this.page = 1;
        this.encounters = [];
        this.hasMoreData = true;
        this.isSearchLoading = true;
        this.encounterRequestInProgress = false;
        this.cd.markForCheck();
        this.getAllEncounters();
      });

    this.getAllEncounters();
  }

    checkPermissionForSubComponent(subComponentName: string): boolean {
    const component = this.permissinArray.find(
      (c) => c.component === this.componentName
    );

    if (!component) return false;

    const subComponent = component.subComponent.find(
      (s) => s.subComponentName === subComponentName
    );

    if (!subComponent) return false;
    const permission = subComponent.permissions.find((p) => p.isPermission);

    return !!permission;
  }

  canCreatePiEncounter(): boolean {
    return canCreatePiEncounter(this.permissinArray);
  }

  getFirstAvailableSubComponent(): { name: string; route: string } | null {
 
    const subComponents = [
      { name: "History", route: "/reports/oqme" },
      { name: "Record Review", route: "/reports/oqme/record" },
      { name: "Evaluation", route: "/reports/oqme/evaluation" },
      { name: "Editing", route: "/reports/oqme/editor" },
      { name: "Finalize Report", route: "/reports/oqme/finalize_report" },
      { name: "Submit Report", route: "/reports/oqme/submit_report" },
      // { name: "Deposition", route: "/reports/oqme/deposition" },
    ];

    for (let subComponent of subComponents) {
      if (this.checkPermissionForSubComponent(subComponent.name)) {
        return subComponent;
      }
    }
    return null;
  }

  getFirstAvailablePQMESSubComponent(): { name: string; route: string } | null {
    const subComponents = [
      { name: "Record Review", route: "/reports/oqme/record" },
      { name: "Editing", route: "/reports/oqme/editor" },
      { name: "Finalize Report", route: "/reports/oqme/finalize_report" },
      { name: "Submit Report", route: "/reports/oqme/submit_report" },
      // { name: "Deposition", route: "/reports/oqme/deposition" },
    ];

    for (let subComponent of subComponents) {
      if (this.checkPermissionForSubComponent(subComponent.name)) {
        return subComponent;
      }
    }
    return null;
  }

  
    getFirstAvailablePQMES_pyhisicianSubComponent(): { name: string; route: string } | null {
    const subComponents = [
       { name: "Supplemental", route: "/reports/oqme/supplemental" },
    ];

    for (let subComponent of subComponents) {
      if (this.checkPermissionForSubComponent(subComponent.name)) {
        return subComponent;
      }
    }
    return null;
  }

  getDepositionAvailableSubComponent(): { name: string; route: string } | null {
    const subComponents = [{ name: "Deposition", route: "/reports/oqme/deposition" }];

    for (let subComponent of subComponents) {
      if (this.checkPermissionForSubComponent(subComponent.name)) {
        return subComponent;
      }
    }
    return null;
  }

  private encounterRequestInProgress = false;
  private currentEncountersSub?: Subscription;
  private lastRequestToken = 0;


  
getAllEncounters(): void {
    const isInitial = this.page === 1;
    if (isInitial) {
      this.isLoading = true;
      this.encounters = [];
    } else {
      this.isScrollLoading = true;
    }

    this.encounterRequestInProgress = true;
    this.cd.markForCheck(); 

    const searchQuery = this.searchText?.trim() || '';

    if (this.currentEncountersSub) {
      this.currentEncountersSub.unsubscribe();
      this.currentEncountersSub = undefined;
    }

    const requestToken = ++this.lastRequestToken;

    this.currentEncountersSub = this.service
      .getAllEncounters(
        this.page,
        this.limit,
        searchQuery,
        this.sortStates && this.sortStates.column
          ? [
              {
                active: this.sortStates.column,
                direction: this.sortStates.direction,
              },
            ]
          : []
      )
      .subscribe({
        next: (res) => {
          if (requestToken !== this.lastRequestToken) return;
          const newData = res.data || [];
          if (isInitial) {
            this.encounters = newData;
          } else {
            this.encounters = [...this.encounters, ...newData];
          }
          this.dataSource.data = this.encounters;
          this.hasMoreData = newData.length === this.limit;
          this.applyFilter();
        },
        error: (err) => {
          if (requestToken !== this.lastRequestToken) return;
          console.error("Error loading encounters:", err);
          this.handleError(err);
        },
        complete: () => {
          if (requestToken !== this.lastRequestToken) return;
          this.isLoading = false;
          this.isScrollLoading = false;
          this.isSearchLoading = false;
          this.encounterRequestInProgress = false;
          this.cd.markForCheck(); // Trigger change detection
        },
      });
  }
  
  isValidValue(value: any): boolean {
    return (
      value !== null &&
      value !== undefined &&
      value !== "" &&
      value !== "null" &&
      value !== "undefined"
    );
  }

  /** PI: caseType with IME short codes (UI only); WC: encounterType. */
  displayEncounterOrCaseType(row: {
    encounterType?: string | null;
    caseType?: string | null;
  }): string {
    return formatEncounterTypeForDisplay(row);
  }

  /** PI has no employer party; other empty digital statuses show "--". */
  displayDigitalService(row: { encounterType?: string }, field: string): string {
    if (
      row?.encounterType === "Personal Injury" &&
      field === "employerDigitalService"
    ) {
      return "--";
    }
    const value = row?.[field];
    return this.isValidValue(value) ? String(value) : "--";
  }

  hasDigitalServiceStatus(row: { encounterType?: string }, field: string): boolean {
    return this.displayDigitalService(row, field) !== "--";
  }


// Sort direction: asc / desc (default: latest created first)
sortStates: { column: string; direction: "asc" | "desc" | "" } = {
  column: "createdAt",
  direction: "desc",
};

sortData(event: Sort) {
  const direction: "asc" | "desc" | "" = event.direction;

  this.sortStates = {
    column: event.active,
    direction,
  };

  this.page = 1;

  if (!direction) {
    this.sortStates = { column: "createdAt", direction: "desc" };
  }

  this.getAllEncounters();
}

  // onSearchChange(): void {
  //   this.page = 1;
  //   this.getAllEncounters();
  // }

onSearchChange(searchValue: string): void {
  this.searchText = searchValue?.trim() || '';
  this.isSearchLoading = true;
  this.cd.markForCheck();

  // Debounce the search
  this.searchTextChanged.next(this.searchText);

  // Ensure focus remains on the input
  setTimeout(() => {
    if (this.searchInput) {
      this.searchInput.nativeElement.focus();
    }
  }, 0);
}
  // onScroll(): void {
  //   if (this.hasMoreData) {
  //     this.page++;
  //     this.getAllEncounters();
  //   }
  // }

  onScroll(): void {
  if (
    !this.hasMoreData ||
    this.isLoading ||
    this.isScrollLoading ||
    this.encounterRequestInProgress
  ) {
    return;
  }

  this.page++;
  this.getAllEncounters();
}

onEncounterScroll(event: Event): void {
  const target = event.target as HTMLElement;
  const threshold = 150; // Pixels from bottom to trigger loading
  const position = target.scrollTop + target.clientHeight;
  const height = target.scrollHeight;

  if (position > height - threshold) {
    this.onScroll();
  }
}

  toggleStatusSelection(statusValue: string): void {
    const index = this.selectedStatuses.indexOf(statusValue);
    if (index > -1) {
      this.selectedStatuses.splice(index, 1);
    } else {
      this.selectedStatuses.push(statusValue);
    }
  }

  // Reset Status Filter
  // resetStatusFilter(): void {
  //   this.selectedStatuses = [];
  //   this.selectedStatusLabel = "Filter by status";
  //   this.applyFilter();
  // }

  resetStatusFilter(): void {
  this.selectedStatuses = [];
  this.selectedStatusLabel = "Filter by status";
  this.isLoading = true;
  this.cd.markForCheck();
  this.applyFilter();
}


  applyStatusFilter(trigger: any): void {
  this.selectedStatusLabel =
    this.selectedStatuses.length > 0
      ? this.selectedStatuses
          .map((status) => this.getStatusLabel(status))
          .join(", ")
      : "Filter by status";

  this.isLoading = true;
  this.cd.markForCheck();
  this.applyFilter();
  trigger.closeMenu();
}



  applyFilter(): void {
    let filteredData = [...this.encounters];

    if (this.selectedStatuses.length > 0) {
      filteredData = filteredData.filter((encounter) =>
        this.selectedStatuses.includes(encounter.status)
      );
    }

    this.dataSource.data = filteredData;
    this.isLoading = false;
    this.isSearchLoading = false;
    this.cd.markForCheck();
  }

  private getStatusLabel(statusValue: string): string {
    const status = this.statusOptions.find((opt) => opt.value === statusValue);
    return status ? status.label : "";
  }

  redirectToURL(form101Id: string) {
    const dialogRef = this.dialog2.open(this.pdfDialogTemplate);

    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.googleUrlService.getDriveUrl(form101Id, 'preview')
    );
  }

  viewApplicantServiceFrom(data) {
    const dialogRef = this.dialog2.open(ViewPDFComponent, {
      data: { mode: "edit", data, type: "Applicant" },
      width: "800px",
      height: "auto",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === "success") {
        this.reloadEncounters();
      }
    });
  }

  viewApplicantAttorneyServiceFrom(data) {
    const dialogRef = this.dialog2.open(ViewPDFComponent, {
      data: { mode: "edit", data, type: "AA" },
      width: "800px",
      height: "auto",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === "success") {
        this.reloadEncounters();
      }
    });
  }
  viewdefenseAttorneyServiceFrom(data) {
    const dialogRef = this.dialog2.open(ViewPDFComponent, {
      data: { mode: "edit", data, type: "DA" },
      width: "800px",
      height: "auto",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === "success") {
        this.reloadEncounters();
      }
    });
  }

  viewEmployerServiceFrom(data) {
    const dialogRef = this.dialog2.open(ViewPDFComponent, {
      data: { mode: "edit", data, type: "Employer" },
      width: "800px",
      height: "auto",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === "success") {
        this.reloadEncounters();
      }
    });
  }

  viewAdjusterServiceFrom(data) {
    const dialogRef = this.dialog2.open(ViewPDFComponent, {
      data: { mode: "edit", data, type: "Insurance" },
      width: "800px",
      height: "auto",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === "success") {
        this.reloadEncounters();
      }
    });
  }

  private reloadEncounters(): void {
    this.isLoading = true;
    this.page = 1;
    this.encounters = [];
    this.hasMoreData = true;
    this.getAllEncounters();
  }

  handleError(err: any) {
    if (err.status === 401) {
      this.errorMessage = "You do not have permission to access this route.";
    } else {
      this.errorMessage =
        "An unexpected error occurred. Please try again later.";
    }
    this.isLoading = false;
  }

  trackByProperty<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }

  canCopyConsentPermalinkForRow(row: any, statusField: string): boolean {
    return canCopyEncounterConsentPermalink(row, statusField);
  }

  copyConsentPermalinkForRow(row: any, statusField: string): void {
    copyEncounterConsentPermalinkForRow(
      this.authService,
      this.toastr,
      row,
      statusField
    );
  }

  Delete(id: string) {
    return this.dialog
      .confirmDialog({
        title: "Confirm Action",
        message: `Do you want to delete this ?`,
        confirmCaption: "Confirm",
        cancelCaption: "Cancel",
        confirmAction: () =>
          this.service.delete(id).pipe(
            tap((res: any) => {
              this.toastr.success(res?.message || "Deleted successfully");
            }),
            catchError((err) => {
              this.toastr.error(
                err?.error?.message || "Failed to delete encounter"
              );
              return throwError(() => err);
            })
          ),
      })
      .subscribe({
        next: (confirmed: boolean) => {
          if (confirmed) {
            this.reloadEncounters();
          }
        },
      });
  }

  openPiEncounter(encounterId: string, row?: any): void {
    const report = row || {};
    const candidates: Array<{ name: string; route: string; statusKeys: string[] }> = [
      {
        name: "Evaluation",
        route: "/reports/oqme/evaluation",
        statusKeys: ["evaluation_status", "evaluation_status_2"],
      },
      {
        name: "Phone Call",
        route: "/reports/oqme/phone_call",
        statusKeys: ["phone_call_status", "phone_call_status_2"],
      },
      {
        name: "Physician Record Review",
        route: "/reports/oqme/physician_record_review",
        statusKeys: [
          "physician_record_review_status",
          "physician_record_review_status_2",
        ],
      },
      {
        name: "Court Appearance",
        route: "/reports/oqme/court_appearance",
        statusKeys: ["court_appearance_status", "court_appearance_status_2"],
      },
      {
        name: "Deposition",
        route: "/reports/oqme/deposition",
        statusKeys: ["deposition_court_status", "deposition_court_status_2"],
      },
      {
        name: "History",
        route: "/reports/oqme",
        statusKeys: ["history_status", "history_status_2"],
      },
      {
        name: "Record Review",
        route: "/reports/oqme/record",
        statusKeys: ["record_status", "record_status_2"],
      },
      {
        name: "Editing",
        route: "/reports/oqme/editor",
        statusKeys: ["editor_status", "editor_status_2"],
      },
      {
        name: "Submit Report",
        route: "/reports/oqme/submit_report",
        statusKeys: ["report_submission_status", "report_submission_status_2"],
      },
    ];

    const unlocked = candidates.find(
      (c) =>
        this.checkPermissionForSubComponent(c.name) &&
        c.statusKeys.some((k) => report[k] != null)
    );
    const permitted = candidates.find((c) =>
      this.checkPermissionForSubComponent(c.name)
    );
    const target =
      unlocked?.route ||
      permitted?.route ||
      ((this.roleName || "").toUpperCase() === "PHYSICIAN"
        ? "/reports/oqme/evaluation"
        : "/reports/oqme");

    this.router.navigateByUrl(
      `${target}?id=${encodeURIComponent(encounterId)}`
    );
  }

  openPDF(fileId: string): void {
    const driveLink = this.googleUrlService.getDriveUrl(fileId, 'view');
    window.open(driveLink, "_blank");
  }

  ngOnDestroy() {
    this.encounters = [];
    if (this.currentEncountersSub) {
      this.currentEncountersSub.unsubscribe();
    }
    this.searchDebounceSub?.unsubscribe();
    this.authStatusSub.unsubscribe();
  }
}
